import React, { useState, useEffect } from 'react';
import { Tooltip, IconButton, Grid, Menu, MenuItem, Dialog, DialogTitle, DialogContent, DialogContentText, Alert, DialogActions, Button } from '@mui/material';


import makeStyles from '@mui/styles/makeStyles';
import Helmet from 'react-helmet';

import {
    Portlet,
    PortletBody,
    PortletHeader,
} from "../../partials/content/Portlet";
import { PagedTable } from '../../common';
import { infoToastify } from '../../util/toast';
import classNames from 'classnames';
import { Delete as DeleteIcon,Edit  as EditIcon} from '@mui/icons-material';
import { ROLE_ADMIN, ROLE_PARTNER_ADMIN, ROLE_SUPERADMIN } from '../../store/constants/roles';
import { DependencyDialog } from './DependencyDialog';
import {MasterImport} from './MasterImport';
import {ImportConfirmationDialog} from './ImportConfirmationDialog';
import CloudSyncIcon from '@mui/icons-material/CloudSync';
import { EditDrgDialog } from './EditDrgDialog';
import GridPopover from '../../common/GridPopover/GridPopover';
import AddCircleIcon from '@mui/icons-material/AddCircle';

const DEFAULT_SORT = [{ id: 'code', direction: 'asc' }];
const SHOW_SEARCH_FILTERS = true;

const useStyles = makeStyles((theme) => ({
    root: {
        margin: 'auto',
    },
    button: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(1),
    },
    icon: {
        fontSize: 17,
        marginTop: 1,
    },
}));

export default function HospitalServicesPage({
    intl, hospitalServicesData, hospitalServicesFields, checkboxStatus,
    userRole, history,
    facilities,
    syncPending,
    actions: {
        hospitalServicesLanding,
        searchGetByName,
        searchReset,
        resetPagedTable,
        setList,
        setSelectedItems,
        setHopsitalServicesDependencyDialog,
        setMasterSelectedItems,
        setHopsitalServicesImportConfirmationDialog,
        setHopsitalServicesLookupDialog,
        getFacilities,
        setEditDrgDialog,
        setSyncToShoppables
    }
}) {

    const [refresh, setRefresh] = useState(Promise.resolve());
    const [syncCallbackDialog, setSyncCallbackDialog] = useState(false);

    const classes = useStyles();

    const handleSyncCallbackDialogClose = () => {
        setSyncCallbackDialog(false);
    }

    const handleSyncCallbackDialogOpen = () => {
        infoToastify(<><b>Syncing Hospital Services</b><br/>You'll be notified when it's complete.</>);
    }

    function handleLookupHospitalServices(codeType) {
        setHopsitalServicesLookupDialog({open:true, codeType: codeType});
    }

    function handleBulkDelete() {
        setHopsitalServicesDependencyDialog({ open: true });
    }

    function handleImportHospitalServices(codeType) {
        setHopsitalServicesImportConfirmationDialog({open:true, codeType: codeType});
    }

    function tableLevelActions() {
        return (
            <>
            <Grid item>
                <Tooltip title="Sync to Shoppables">
                    <IconButton aria-label="sync" size='small'
                            onClick={()=> setSyncToShoppables(handleSyncCallbackDialogOpen)}
                        >
                        <CloudSyncIcon />
                    </IconButton>
                </Tooltip>
            </Grid>
            <GridPopover
                title="Import from Historical data"
                icon={<i className="fas fa-upload"></i>}
                nameofButtons={[
                    "DRG CODES",
                    "ICD10-PCS CODES",
                    "HIPPS CODES"
                ]}
                handleClicks={[
                    () => handleImportHospitalServices("DRG"),
                    () => handleImportHospitalServices("ICD10-PCS"),
                    () => handleImportHospitalServices("HIPPS")
                ]}
            />
            <GridPopover
                title="Add Codes"
                icon={<AddCircleIcon />}
                nameofButtons={[
                    "DRG CODES",
                    "ICD10-PCS CODES",
                    "HIPPS CODES"
                ]}
                handleClicks={[
                    () => handleLookupHospitalServices("DRG"),
                    () => handleLookupHospitalServices("ICD10-PCS"),
                    () => handleLookupHospitalServices("HIPPS")
                ]}
            />
            {(userRole === ROLE_SUPERADMIN || userRole === ROLE_PARTNER_ADMIN || userRole === ROLE_ADMIN) &&
                <Grid item>
                    <Tooltip title="Delete Hospital services">
                        <IconButton aria-label="delete" size='small'
                            onClick={handleBulkDelete}
                        >
                            <DeleteIcon />
                        </IconButton>
                    </Tooltip>
                </Grid>
            }
                
            </>
        );
    }

    function handleLoad(sort, filter, pagination) {
        hospitalServicesLanding(pagination, sort, filter);
    }

    function handleRefresh() {
        setList([]);
        setMasterSelectedItems([]);
        setRefresh(Promise.resolve());
    }

    useEffect(() => {
        const pageName = {
            name: 'hospitalservices-landing'
        }
        searchGetByName(pageName);

        return function cleanup() {
            searchReset();
            resetPagedTable(pageName.name);
            setSelectedItems([]);
        }
    }, [searchGetByName]);

    useEffect(() => {
        getFacilities()
    }, [getFacilities]);

    const hospitalServicesActions = (data) => (

        <IconButton
            color="primary"
            aria-label="Edit"
            onClick={() => {setEditDrgDialog({open:true,data})}}
            size="large"
        >
            <Tooltip title="Edit">
                <EditIcon />
            </Tooltip>
        </IconButton>
    );
    
    return (
        <>
            <Helmet title="Hospital Services" />
            <Portlet>
                <PortletHeader
                    title="Hospital Services"
                    handleRefresh={handleRefresh}
                    showSearchFilters={SHOW_SEARCH_FILTERS}
                    showSearchFiltersDropdown={false}
                    name="hospitalservices-landing"
                />
                <PortletBody>
                    <div className="row">
                        <div className="col-md-12">
                            <PagedTable
                                shouldRenderLazy={true}
                                name="hospitalservices-landing"
                                fields={hospitalServicesFields}
                                data={hospitalServicesData}
                                onLoad={handleLoad}
                                refresh={refresh}
                                defaultSort={DEFAULT_SORT}
                                tableLevelActions={tableLevelActions}
                                hasCheckbox={true}
                                showSelectAll={true}
                                tableLevelLoading={syncPending}
                                title="Hospital Service"
                                criteriasSaveEnabled={true}
                                showSearchFilters={SHOW_SEARCH_FILTERS}
                                hasActions={true}
                                renderActionColumn={hospitalServicesActions}
                            />
                        </div>
                    </div>
                </PortletBody>
            </Portlet>
            <DependencyDialog handleRefresh={handleRefresh} />
            <ImportConfirmationDialog handleRefresh={handleRefresh} />
            <MasterImport handleRefresh={handleRefresh} facilities={facilities?.filter((item)=>(item?.active && item)) || []}/>
            <EditDrgDialog setEditDrgDialog={setEditDrgDialog} facilities={facilities || []} handleRefresh={handleRefresh}/>
            <Dialog open={syncCallbackDialog} onClose={handleSyncCallbackDialogClose}>
                <DialogTitle>
                    Sync to Shoppables
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <Alert severity="success">The hospital services successfully sync to shoppables.</Alert>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleSyncCallbackDialogClose}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}